import {
  requestGet,
  requestPost,
  requestPut,
  requestPatch,
  requestDelete,
} from "../config/Api";
import { downloadFilePost } from "./ReportService";

const name = "workspace/tasks";

export const getWorkspaceTasks = (params) => {
  return requestGet(name, { params });
};

export const updateWorkspaceTask = (id, task) => {
  return requestPut(`${name}/${id}`, task);
};

export const updateWorkspaceTaskStatus = (id, payload) => {
  return requestPatch(`${name}/${id}/status`, payload);
};

export const reassignWorkspaceTask = (id, payload) => {
  return requestPatch(`${name}/${id}/assignee`, payload);
};

export const deleteWorkspaceTask = (id) => {
  return requestDelete(`${name}/${id}`);
};

export const getWorkspaceTaskById = (id) => {
  return requestGet(`${name}/${id}`);
};

export const createWorkspaceTask = (task) => {
  return requestPost(name, task);
};

export const getWorkspaceTaskLegalFiles = (id, params) => {
  return requestGet(`${name}/${id}/legal-files`, { params });
};

export const exportWorkspaceTaskReport = (id, payload) => {
  return downloadFilePost(`${name}/${id}/report/export`, payload);
};
